export default "__VITE_ASSET__Cac19zYq__"